import { declareFieldMeanings, identity, means } from '../../../src/issues/field-meanings';

/** What each Rent Board housing-inventory detail means to an owner. */
export const fieldMeanings = declareFieldMeanings({
  sources: ['sf-rent-board'],
  declarations: [
    identity('year'),
    means('status', 'the reporting status', ['reportingStatus']),
    means('status', 'the rent-increase licence status', ['licenseStatus']),
    means('deadline', 'the licence expiration date', ['expiresOn'], {
      matters: 'changes how long the licence stays valid',
    }),
  ],
});
